import { render, staticRenderFns } from "./PreRegisterBTP.vue?vue&type=template&id=72821cc6"
import script from "./PreRegisterBTP.vue?vue&type=script&lang=js"
export * from "./PreRegisterBTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports